import ApiService from "../api";

export default class AtribuicaoEtapaConfigService extends ApiService {

    constructor() {
        super('/api/solicitacoes/config/atribuicoes')
    }

    listar() {
        return this.get(``)
    }

    cadastrar(dados) {
        return this.post(``, dados)
    }

    atualizar(id, dados) {
        return this.put(`/${id}`, dados)
    }

    excluir(id) {
        return this.delete(`/${id}`)
    }

    listarUsuariosElegiveis(tipoProcesso, etapaCodigo) {
        return this.get(`/${tipoProcesso}/${etapaCodigo}/usuarios-elegiveis`)
    }
}
